module.exports = __webpack_public_path__ + "static/media/eye13.0b215b73.jpeg";